// extracted by mini-css-extract-plugin
export default {"counterButton":"Counter_counterButton__HH3kY","counterValue":"Counter_counterValue__5ZDaq"};